import { useState } from 'react'
import { promptInstall } from './pwaState'
import { getInstallHint, usePwa } from './usePwa'

/**
 * "Install app" row for the navigation drawer. Uses the native install dialog when the browser
 * offers one (Chrome, Edge, Samsung Internet) and otherwise shows how to install by hand
 * (iPhone / iPad Safari, Safari on Mac, Firefox). Hidden once the app is already installed.
 */
export default function InstallAppItem() {
  const { installed, installPromptAvailable } = usePwa()
  const [hint, setHint] = useState(null)
  if (installed) return null

  const handleClick = async () => {
    if (installPromptAvailable) {
      await promptInstall()
      return
    }
    setHint((current) => (current ? null : getInstallHint()))
  }

  return (
    <>
      <p className="px-[var(--gutter)] pt-8 text-[14px] text-m1-muted">App</p>
      <div className="px-[var(--gutter)] pt-2">
        <button
          type="button"
          onClick={handleClick}
          className="flex min-h-[52px] w-full items-center gap-3 border-b border-[#272C32] py-2 text-left text-[19px] font-light leading-snug text-m1-ink transition-colors hover:text-m1-violet"
        >
          <i className="ri-install-line text-xl" aria-hidden="true" />
          Install app
        </button>
        {hint && (
          <p className="py-3 text-[14px] font-light leading-relaxed text-m1-muted">{hint}</p>
        )}
      </div>
    </>
  )
}
